import React from "react";
import { Component } from "react";
import BookingTable from "../components/BookingTable";
import { UserContext, withUserConsumer } from "../context/UserContext";
import NoBookings from "../components/NoBookings";

class Dashboard extends Component{
  static contextType = UserContext;

  render(){
    // console.log(this.context.user)

    if(this.context.user.bookings.length === 0){
      return(
        <div>
          <NoBookings />
        </div>
      )
    }

    return (
      <div>
        <br />
        <BookingTable userInfo={this.context.user}/>     
      </div>
        
    )
  }

  
}


export default withUserConsumer(Dashboard)